'use strict';exports.__esModule = true;exports.resetSliderState = exports.setSliderState = exports.loadProperties = undefined;var _initialState;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);
var _constants = require('../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var loadProperties = (0, _reduxAct.createAction)('/LOAD_PROPERTIES');
var loadPropertiesSuccess = (0, _reduxAct.createAction)('/LOAD_PROPERTIES_SUCCESS');
var loadPropertiesFail = (0, _reduxAct.createAction)('/LOAD_PROPERTIES_FAIL');
var setSliderState = (0, _reduxAct.createAction)('/SET_SLIDER_CONFIG');
var resetSliderState = (0, _reduxAct.createAction)('/RESET_SLIDER_CONFIG');

var initialState = (_initialState = {
  loaded: false }, _initialState[
_constants.propertiesSlidersTypes.FOR_SALE + 'SliderState'] = {
  index: 0,
  city: undefined,
  type: undefined }, _initialState[

_constants.propertiesSlidersTypes.FOR_RENT + 'SliderState'] = {
  index: 0,
  city: undefined,
  type: undefined }, _initialState[

_constants.propertiesSlidersTypes.UP_TO + 'SliderState'] = {
  index: 0,
  city: undefined,
  type: undefined }, _initialState[

_constants.propertiesSlidersTypes.PROPERTY_TYPE + 'SliderState'] = {
  index: 0,
  city: undefined,
  type: 'apartment' }, _initialState[

_constants.propertiesSlidersTypes.PROJECTS + 'SliderState'] = {
  index: 0,
  city: undefined,
  type: undefined }, _initialState[

_constants.propertiesSlidersTypes.FAVORITES + 'SliderState'] = {
  index: 0,
  city: undefined,
  type: undefined }, _initialState);



var fetchLoad = function fetchLoad(_ref) {var _ref$requestType = _ref.requestType,requestType = _ref$requestType === undefined ? 'properties' : _ref$requestType,_ref$params = _ref.params,params = _ref$params === undefined ? {} : _ref$params,carouselType = _ref.carouselType;return _axios2.default.get('/' + requestType + '/search?$limit=20', {
    params: Object.assign({
      country: 'Israel',
      photos: requestType === 'properties' ? true : undefined },
    params.type ? Object.assign({},
    params, { type: [params.type] }) :
    params) }).


  then(function (action) {return loadPropertiesSuccess({ action: action, carouselType: carouselType });}, loadPropertiesFail);};

var handleLoad = function handleLoad(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true }),
  promise(fetchLoad, action));};

var handleLoadSuccess = function handleLoadSuccess(state, _ref2) {var _Object$assign;var action = _ref2.action,carouselType = _ref2.carouselType;
  var data = (0, _get2.default)(action, 'data.data');
  return Object.assign({},
  state, (_Object$assign = {
    loading: false,
    loaded: true }, _Object$assign[
  carouselType] = data, _Object$assign));

};

var handleLoadFail = function handleLoadFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while loading home page properties');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: null,
    error: error });

};

var handleSetSliderState = function handleSetSliderState(state, _ref3) {var _Object$assign2;var carouselType = _ref3.carouselType,index = _ref3.index,city = _ref3.city,type = _ref3.type;return Object.assign({},
  state, (_Object$assign2 = {}, _Object$assign2[
  carouselType + 'SliderState'] = Object.assign({},
  state[carouselType + 'SliderState'], {
    index: index,
    city: city,
    type: type }), _Object$assign2));};



var handleResetSliderState = function handleResetSliderState(state, _ref4) {var _Object$assign3;var carouselType = _ref4.carouselType;return Object.assign({},
  state, (_Object$assign3 = {}, _Object$assign3[
  carouselType + 'SliderState'] = Object.assign({},
  initialState[carouselType + 'SliderState']), _Object$assign3));};



var homePageProperties = (0, _reduxAct.createReducer)(function (on) {
  on(loadProperties, handleLoad);
  on(loadPropertiesSuccess, handleLoadSuccess);
  on(loadPropertiesFail, handleLoadFail);
  on(setSliderState, handleSetSliderState);
  on(resetSliderState, handleResetSliderState);
}, initialState);exports.


loadProperties = loadProperties;exports.
setSliderState = setSliderState;exports.
resetSliderState = resetSliderState;exports.default =


homePageProperties;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/homePageProperties.js
// module id = 589
// module chunks = 0